import React from "react";
import GridToolbarNoExport from "../../../common/GridToolbarNoExport";
import AppDataGrid from "../../../common/AppDataGrid";
import useDataHook from "../hooks/useDataHook";
import moment from "moment";

const DropStudentsRequest = ({ source }) => {
  const { data, loading, error } = useDataHook(source);

  const columns = [
    {
      field: "date",
      headerName: "Date",
      flex: 1,
    },
    {
      field: "student_name",
      headerName: "Student",
      flex: 1,
    },
    {
      field: "dob",
      headerName: "DOB",
      flex: 1,
    },
    {
      field: "course_name",
      headerName: "Course",
      flex: 1,
    },
    {
      field: "school_name",
      headerName: "School",
      flex: 1,
    },
    {
      field: "from_name",
      headerName: "From Name",
      flex: 1,
    },
    {
      field: "from_email",
      headerName: "From Email",
      flex: 1,
    },

    {
      field: "comments",
      headerName: "Comments",
      flex: 1,
    },
  ];

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <>
      <AppDataGrid
        rows={data}
        columns={columns}
        loading={loading}
        slots={{ toolbar: GridToolbarNoExport }}
        pagination
        pageSize={10}
        rowsPerPageOptions={[10, 25, 50]}
        disableSelectionOnClick
      />
    </>
  );
};

export default DropStudentsRequest;
